"use strict";

var _type = require("../_utils/type");
var StatusTypes = (0, _type.tuple)('validating', 'success', 'error');